import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";

const AddGrade = () => {
  const { id } = useParams();
  const location = useLocation();
  const { row } = location.state || {};
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { 
    "Content-Type": "application/json",
    "auth-token": authToken, 
    "authorization": accessToken 
  };
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    status: "Active"
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);

  useEffect(() => {
    if (id && row) {
      setFormData({
        name: row?.name || "",
        status: row?.status || "Active"
      });
    }
  }, [id, row]);

  const validate = () => {
    const newErrors = {};

    if (!formData.name?.trim()) {
      newErrors.name = "Grade name is required.";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      // Prepare payload as JSON (not FormData based on your API)
      const payload = {
        name: formData.name.trim(),
        status: formData.status
      };

      // Add ID for update
      if (id) {
        payload.id = parseInt(id);
      }

      let response;

      if (id) {
        // Update existing grade
        response = await APIServices.put(
          "/admin/cms/grade_update",
          payload,
          headers
        );
      } else {
        // Add new grade
        response = await APIServices.post(
          "/admin/cms/grade_add",
          payload,
          headers
        );
      }

      // Check response
      if (response?.data?.status === true) {
        showToast(
          response?.data?.message || (id ? "Grade updated successfully" : "Grade added successfully"),
          "success"
        );
        setTimeout(() => {
          navigate("/admin/grade");
        }, 2000);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        showToast(
          response?.data?.message || "Something went wrong.",
          "error"
        );
      }
    } catch (error) {
      console.error("API call error:", error);
      showToast(
        error.response?.data?.message || "An unexpected error occurred",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="add_grade_sec">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">
            {id ? "Edit Grade" : "Add Grade"}
          </h1>
        </div>

        <Card className="add_grade_form">
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Grade Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter grade name (e.g., Kindergarten, Grade 1, etc.)"
                      value={formData.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name}
                      disabled={loading}
                      maxLength={40}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <div className="text-center mt-4">
                <Button
                  variant="primary"
                  className="me-2"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Processing..." : (id ? "Update" : "Add")}
                </Button>
                <Button
                  variant="secondary"
                  className="me-2"
                  onClick={() => navigate("/admin/grade")}
                  disabled={loading}
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>

      <ToastContainer />
    </>
  );
};

export default AddGrade;